import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { authorization } from "../../api/auth-scripts";
import UserContext from "../../context/UserContext";
import Loader from "../Notifications/Loader";
import { setupInterceptors } from "../../api";

function SafeRoute({ children }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { setUser, user } = useContext(UserContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setupInterceptors(navigator, setUser);
  }, []);

  useEffect(() => {
    const performAuthorization = async () => {
      if (!user) {
        setLoading(true);
        try {
          const authorizedUser = await authorization();
          setUser(authorizedUser);
          const rolePath =
            authorizedUser.role === "reception"
              ? "receptionist"
              : authorizedUser.role;
          const userRolePath = `/${rolePath}`;

          if (!pathname.startsWith(userRolePath)) {
            navigate(userRolePath);
          }
        } catch {
          setUser(null);
          localStorage.removeItem("user");
          if (
            pathname !== "/" &&
            pathname !== "/forgot-password" &&
            pathname !== "/reset-password" &&
            pathname !== "/sign-up" && 
            pathname !== "/otp"
          )
            navigate("/");
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    performAuthorization();
  }, [pathname, navigate, setUser, user]);

  if (loading) return <Loader />;

  return <>{children}</>;
}

export default SafeRoute;
